import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import HotArticlesSection from './components/HotArticlesSection';
import CharacterSection from './components/CharacterSection';
import LatestSection from './components/LatestSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '亲吻姐姐——经典恋爱动漫官方解析站',
    url: 'https://kissxsister-anime.com',
    description: '亲吻姐姐全集剧情解析、角色介绍、声优阵容及粉丝社区讨论',
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '亲吻姐姐官方解析站',
    url: 'https://kissxsister-anime.com',
    description: '致力于为亲吻姐姐粉丝提供最全面的动漫内容解析',
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <HotArticlesSection />
        <CharacterSection />
        <LatestSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}